import { gql } from "@apollo/client";

export const FEEDBACK_SUBMIT = gql`
  mutation FeedbackSubmit($input: FeedbackSubmitInput!) {
    feedbackSubmit(input: $input) {
      success
      errors {
        code
        field
        message
      }
    }
  }
`;
